import Image from "next/image";
import Link from "next/link";
import React from "react";
import { ImgPath } from "utils/Constant";
interface propsType {
  alignLogo?: string;
}
const CommonLogo = ({ alignLogo }: propsType) => {
  return (
    <Link
      className={`logo ${alignLogo ? alignLogo : ""} `}
      href="dashboard/default"
    >
      <Image
        width={350}
        height={35}
        className="img-fluid for-light"
        src={`/${ImgPath}/ido_logo_rev.png`}
        alt="looginpage"
      />
      <Image
        width={350}
        height={35}
        className="img-fluid for-dark"
        src={`/${ImgPath}/ido_logo_rev.png`}
        alt="looginpage"
      />
    </Link>
  );
};

export default CommonLogo;
